import React from "react";
import { ReactComponent as ErrorLogo } from "../../assets/error.svg";
import { ReactComponent as SuccessLogo } from "../../assets/celebrate.svg";
import { ReactComponent as PendingLogo } from "../../assets/pending-icon.svg";
import styles from "./StatusMessage.module.css";
import { ReactComponent as KlashaBlackLogo } from "../../assets/logo-black.svg";
import { ReactComponent as LockIcon } from "../../assets/lock.svg";

type MessageType = "error" | "success" | 'pending';
type CustomMessageType = string | React.ReactNode;

export const StatusMessage = ({ type, message }: { type: MessageType; message?: CustomMessageType }) => {
  if (type === "error") {
    return (
      <div className={styles.container}>
        <div className={styles.container_inner}>
          <div className={styles.main}>
            <ErrorLogo />
            <div className={styles.texts}>
              <p className={styles.text}>Your payment was unsuccessful</p>
              <p className={styles.customText}>{message}</p>
              <p className={styles.subtext}>
              Redirecting you back to merchant.
              </p>
            </div>
          </div>
          <div className={styles.securedText}>
            <LockIcon />
            <p>Secured by</p>
            <KlashaBlackLogo />
          </div>
        </div>
      </div>
    );
  }
    if (type === "pending") {
    return (
      <div className={styles.container}>
        <div className={styles.container_inner}>
          <div className={styles.main}>
            <PendingLogo />
            <div className={styles.texts}>
              <p className={styles.text}>Your payment is still pending</p>
              <p className={styles.customText}>{message}</p>
              <p className={styles.subtext}>
              Redirecting you back to merchant.
              </p>
            </div>
          </div>
          <div className={styles.securedText}>
            <LockIcon />
            <p>Secured by</p>
            <KlashaBlackLogo />
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className={styles.container}>
      <div className={styles.container_inner}>
        <div className={styles.main}>
          <SuccessLogo />
          <div className={styles.texts}>
            <p className={styles.text}>Payment successful</p>
            <p className={styles.customText}>{message}</p>
            <p className={styles.subtext}>
              Redirecting you back to merchant.
            </p>
          </div>
        </div>
        <div className={styles.securedText}>
          <LockIcon />
          <p>Secured by</p>
          <KlashaBlackLogo />
        </div>
      </div>
    </div>
  );
};
